<template>
  <div class="list-group list-group-flush mx-3 mt-4 flex-row-sm mb-1-sm flex-wrap-sm">
      <div
         class="ripple list-group-item-action d-flex cursor-pointer" 
         v-for="item in routesChildren || routes"
         @click.prevent="goTo(item,$event)"
         :key="item.id">
        <a
        class="py-2 d-flex gap-3 align-items-center fw-bold" 
        :class="[item.class, route.path.includes(item.path) ? 'sidebar-active' : '']"
        aria-current="true"
        :href="item.path"
        style="padding: 0; border: 0"
        
      >
        <div :class="[item.icon, 'd-none-sm']"></div>
        <span class="side-bar-item">{{ $t(item.name) }}</span>
        <!-- <span  @click.stop.prevent.capture="handleMenuClick(item)">></span> -->
      </a>
      <ul id="collapseExample1" class="collapse list-group list-group-flush">
        <li v-if="item?.children?.length" class="list-group-item py-1">
          <custom-router :routesChildren="item.children" :parentId="item.id"></custom-router>
        </li>
      </ul>
      </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import menus from './menu.js'
const routes = reactive(menus)
const props = defineProps(['routesChildren', 'parentID'])
const router = useRouter()
const route = useRoute()

function goTo(item, event) {
  event.preventDefault()
  router.push({
    name: item.path
  })
  
}


defineOptions({
    name: 'CustomRouter'
})

</script>

<style></style>
